<template>
  <div class="layout-container">
    <XTopMenu :menus="filteredTopRoutes" class="top-menu" />
    <div class="flex">
      <XLeftMenu />
      <router-view class="flex1 p10" />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    created() {},
    computed: {
      // 获取当前用户角色
      adminRole() {
        return localStorage.getItem('admin_role')
      },

      // 过滤顶部菜单 (一级菜单)
      filteredTopRoutes() {
        // 过滤没有子路由并且符合角色的一级菜单
        return this.$router.options.routes.filter(route => {
          // 如果有子路由，直接跳过
          if (route.children && route.children.length > 0) {
            return false
          }
          // 过滤符合角色的路由
          return route.role_name && route.role_name === this.adminRole
        })
      },

      // 过滤左侧菜单 (子路由)
      filteredLeftRoutes() {
        // 递归过滤有子路由的菜单
        const filterRoutes = routes => {
          return routes.filter(route => {
            if (route.children && route.children.length > 0) {
              // 递归过滤子路由
              route.children = filterRoutes(route.children)
              // 如果子路由符合条件，保留父路由
              return route.children.length > 0
            }
            return false
          })
        }

        return filterRoutes(this.$router.options.routes)
      }
    }
  }
</script>

<style scoped>
  .layout-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  .top-menu {
    position: sticky; /* 使用 sticky 固定在顶部 */
    top: 0;
    z-index: 10; /* 确保菜单在其他内容之上 */
    width: 100%;
    background-color: #fff; /* 背景色可选，防止内容被遮挡 */
  }
</style>
